const axios = require('axios');
import config from './Config';
import systemService from './SystemService';
import * as xml2js from 'xml2js';
import router from '../router';
import securityService from "./SecurityService";
import { Buffer } from 'buffer';

class CrApi {
    public async request(section, action, params = {}, files = {}) {
        const router = (await import('../router')).default;
        const securityService = (await import('../service/SecurityService')).default;

        params['section'] = section;
        params['action'] = action;
        const apiUrl = config.apiUrl;

        const fd = new FormData();
        for (const k of Object.keys(params)) {
            fd.append(k, params[k]);
        }
        for (const k of Object.keys(files)) {
            fd.append(k, files[k]);
        }
        fd.append('website_token', securityService.getToken());

        let res;
        let xmlString;
        let response;
        response = {
            status: 200,
            data: {
                xml: undefined
            }
        };
        try {
            if (Object.keys(files).length > 0) {
                // make multipart requests if there is a file to upload
                let requestConfig = { headers: {} };
                requestConfig.headers['Content-Type'] = undefined;
                res = await axios.post(apiUrl, fd, requestConfig);

                xmlString = res.data;
            } else {
                try {
                    res = await axios.post(apiUrl, params)
                    xmlString = res.data;

                } catch(e) {
                    if (e && e['status'] === 200) {
                        xmlString = e['responseText'];
                    } else {
                        throw e;
                    }
                }
            }

            // cleanup response from chars that cause the xml parsing to fail
            // 0 – NULL – Null character
            // 28 – FS – File separator
            // 29 – GS – Group separator
            // 30 – RS – Record separator
            // 31 – US – Unit separator
            for(const c of [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 11, 12, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31]) {
                xmlString = xmlString.replace(new RegExp(String.fromCharCode(c), 'g') , '');
            }
            response.data.xml = await new Promise((resolve, reject) => {
                new xml2js.Parser({
                    explicitArray: false,
                    mergeAttrs: true,
                    attrNameProcessors: [(name) => {
                        return '_' + name;
                    }],
                    charkey: '__text'
                }).parseString(xmlString, (err, result) => {
                    if (err) {
                        reject(err);
                    } else {
                        resolve(result.xml);
                    }
                });
            });
            // Redirect if not authenticated. This could be implemented as a request interceptor, but it would be a waste of
            // resources to parse the xml there too. This can be moved to request interceptor once authentication failure
            // response is implemented as a http status code (401)
            systemService.isOnline = true;
            if (response.data.xml == null) {
                systemService.isOnline = false;
                return;
            }
        } catch (e) {
            console.log('error', e);
        }

        let currentRoute = router.currentRoute;
        let currentRouteName = router.currentRoute['name'];
        // patch for scan edit where securescan send no response. It is for scans with -1 as status
        if (!response.data.xml && (currentRouteName == 'crapp.edit_scan' || currentRouteName == 'account.scans.edit')) {
            response.data = {
                xml: {
                    message: {
                        status: -1
                    }
                }
            };
        }

        try {
            if (response.data.xml.error && response.data.xml.error._code == 41) {
                if (currentRouteName != 'app.maintenance') {
                    window.location.href = '/maintenance/';
                }
            } else if (response.data.xml.error && response.data.xml.error._code == 111) {
                securityService.signOut();
                window.location.href = '/limitreached/';
            }else {
                if (typeof response.data.xml.error != 'undefined') {
                    if (response.data.xml.error._code == 101) {
                        if (currentRouteName.substring(0, 2) == "AP") {
                            window.location.href = '/attendance/signin/?referenceState=' + encodeURI(currentRoute['name']) + '&referenceParams=' + encodeURI(JSON.stringify(currentRoute['query']));
                        } else if (currentRouteName.substring(0, 2) == 'UP') {
                            if (currentRoute['fullPath'].split('/?')[1] === undefined) {
                                window.location.href = window.location.protocol + "//" + window.location.host + "/share/preview/account/login/";
                            } else {
                                window.location.href = window.location.protocol + "//" + window.location.host + "/share/preview/account/login/?" + window.location.href.split('/?')[1];
                            }
                        } else if (currentRouteName.substring(0, 3) == "CIO") {
                            window.location.href = '/checkinout/signin/?referenceState=' + encodeURI(currentRoute['name']) + '&referenceParams=' + encodeURI(JSON.stringify(currentRoute['query']));
                        }   else {
                            securityService.destroyToken();
                            window.location.href = '/signin?to=' + currentRoute['fullPath'];
                        }
                    }
                }
            }
        } catch (e) {
            // catch postbacktool error
            console.log("error", e);
        }

        return response;
    };

    public async requestV2(uri:string, params = {}, files = {}) {
        const url = config.apiUrlV2 + uri.replace(/^\/|\/$/g, '') + '/';
        const requestConfig = { headers: {} };
        let fd;
        if (Object.keys(files).length > 0) {
            // make a multipart requests if there is a file to upload
            fd = new FormData();
            for (const k of Object.keys(params)) {
                fd.append(k, params[k]);
            }
            for (const k of Object.keys(files)) {
                fd.append(k, files[k]);
            }
            fd.append('params', JSON.stringify(params));
            requestConfig.headers['Content-Type'] = 'multipart/form-data';
        }

        let response = null;
        try {
            const res = await axios.post(url, fd ? fd : params, requestConfig);
            response = res.data;
        } catch (error) {
            response = error['response'] ? error['response']['data'] : null;
        }

        let currentStateName = router.currentRoute.value['name'];
        if (response.error && response.error == 'ERROR_MAINTENANCE' && currentStateName !== 'app.maintenance') {
            window.location.href = '/maintenance/';
        } else if (router.currentRoute.value['meta']['authenticate'] !== false && response.error === 'AUTH_FAILED') {
            securityService.signOut();
        } else if (response.error && response.error === 'VERIFY_EMAIL') {
            window.location.href = '/verify-email';
        } else if (response.error && response.error === 'LIMIT_MINUTE') {
            securityService.signOut();
            window.location.href = '/limitreached/';
        }

        return response;
    };

    public extractCollection(o) {
        if (Array.isArray(o)) {
            return o;
        } else if (o === undefined) {
            return [];
        } else {
            return [o];
        }
    };

    public async barcodeV2Url(params) {
        let res;
        let image;
        const apiUrl = config.barcodeBaseUrl + '/api-v2/barcode/generate/';
        try {
            res = await axios.post(
                apiUrl,
                params,
                {responseType: 'arraybuffer'});
            image = new Buffer(res.data, 'binary').toString('base64');
        } catch(e) {
            console.log(e);
        }
        return "data:image/png;base64, " + image;
        //return config.barcodeBaseUrl + '/api-v2/barcode/generate/?params='+encodeURIComponent(JSON.stringify(params));
    }

    public barcodeUrl(value, valueSize = 0, options = undefined) {
        options = options === undefined ? {} : options;
        let strOptions = '';
        for (const k of Object.keys(options)) {
            strOptions += '&' + k + '=' + options[k];
        }

        return config.barcodeBaseUrl + '/api/?'
            + 'section=barcode&action=generate&website_token=' + securityService.getToken() + '&value=' + encodeURIComponent(value)+'&valuesize='+valueSize + strOptions;
    };

    public barcodeTemplateLogoUrl(filename) {
        return config.apiUrl
            + '?section=barcodetemplate&action=getlogofile&filename=' + encodeURIComponent(filename) + '&website_token=' + securityService.getToken();
    };

    public async barcodeTemplateLogoUrlV2(filename) {
        let params = {
            fileName: filename,
            website_token: securityService.getToken()
        };

        let res;
        let image;
        const apiUrl = config.apiUrlV2 + 'barcode_template/download_logo/';
        try {
            res = await axios.post(apiUrl, params, {
                responseType: 'arraybuffer'
            });

            image = new Buffer(res.data, 'binary').toString('base64');
        } catch(e) {
        }
        return "data:image/png;base64, " + image;
        //return config.apiUrlV2+'barcode_template/download_logo/'+ '?params=' + encodeURIComponent(JSON.stringify(params)) ;

    };
}

export default new CrApi();
